<template lang="html">
  <v-text-field
    :id="'autocomplete' + idSuffix"
    :label="label"
    :rules="rules"
    :value="value"
    @input="$emit('input', $event)"
    @keydown="handleKeyDown"
    class="autocomplete-input"
    type="text"
    placeholder=""
    autocomplete="off"
  >
    <template #prepend-inner>
      <v-icon :color="prependIcon.color ? prependIcon.color : 'grey'">
        {{ prependIcon.icon ? prependIcon.icon : prependIcon }}
      </v-icon>
    </template>
    <template #append>
      <v-icon :color="appendIcon.color ? appendIcon.color : 'grey'">
        {{ appendIcon.icon ? appendIcon.icon : appendIcon }}
      </v-icon>
    </template>
  </v-text-field>
</template>

<script>
import validator from './validator'
export default {
  props: {
    value: {
      required: true,
      validator: v => validator(v, { string: true, nil: true })
    },
    idSuffix: {
      required: true,
      type: [String, Number],
      default: `${Math.random()*100}`
    },
    handleKeyDown: {
      required: true,
      type: Function,
      default: () => alert('key handler not implemented')
    },
    label: {
      required: false,
      type: String,
      default: "Autocomplete Input"
    },
    prependIcon: {
      required: false,
      validator: v => validator(v, { string: true, object: true }),
      default: 'mdi-flag'
    },
    appendIcon: {
      required: false,
      validator: v => validator(v, { string: true, object: true }),
      default: 'mdi-close-circle'
    }
  },
  data: () => ({
    rules: [
      v => !!v || 'This field is required. Please make sure to select from the suggestion dropdown'
    ]
  })
}
</script>

<style lang="css" scoped>
</style>
